import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import ProductCardListingPage from 'bpm/pages/ProductCardManagementPage/ProductListingsPage'
import CompanyPage from 'bpm/pages/ProductsPage/CompanyPage'
import CompetitiveAnalysisPage from 'bpm/pages/ProductsPage/CompetitiveAnalysisPage'
import ProductDetailsPage from 'bpm/pages/ProductsPage/ProductDetailsPage'
import SubmissionPage from 'bpm/pages/ProductsPage/SubmissionPage'


export const ProductsPageRoutes: RouteDictionary = {
    '/': {
        redirect:
            '/all?groupby=sectionNumber%2520false%252CproductType%2520false&sortby=sectionNumber%252CproductType%252Ctype%252ClastUpdated%2520desc&ia=true&defaultFilter=true',
    },
    '/company/:firmId?': {
        name: 'Company',
        component: CompanyPage,
    },
    '/all': {
        name: 'Product Listings',
        component: ProductCardListingPage,
    },
    '/competitive_analysis': {
        name: 'Competitive Analysis',
        component: CompetitiveAnalysisPage,
    },
    '/submissions': {
        name: 'Submissions',
        component: SubmissionPage,
    },
    '/product/listing/:listingId': {
        name: 'Product Details',
        component: ProductDetailsPage,
    },
}
